import { createGlobalStyle } from 'styled-components';
import fonts from './fonts';
import resets from './resets';

const GlobalStyle = createGlobalStyle`
    ${resets}
    ${fonts}
    body {
        height: 100%;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    
    [dir='rtl'] .rtl-aware-icon {
        transform: scale(-1, 1);
    }

    .fade {
        &-enter {
            opacity: 0;

            &-active {
                opacity: 1;
                transition: opacity 500ms;
            }
        }

        &-exit {
            opacity: 1;

            &-active {
                opacity: 0;
                transition: opacity 500ms;
            }
        }
    }

    .fade-in {
        &-enter {
            opacity: 0;

            &-active {
                opacity: 0;
                transition: opacity 500ms;
            }

            &-done {
                opacity: 1;
                transition: opacity 500ms;

            }
        }
    }

    .slide-enter {
        opacity: 0;
        transform: translateY(-100px);
    }
    .slide-exit {
        opacity: 1;
        transform: translateY(0px);
    }
    .slide-enter-active {
        opacity: 1;
        transform: translateY(0px);
    }
    .slide-exit-active {
        opacity: 0;
        transform: translateY(-100px);
    }
    .slide-enter-active,
    .slide-exit-active {
        transition: opacity 0.5s, transform 0.5s;
    }
`;

export default GlobalStyle;
